<template>
    <div class="welcome">
      <h3 class="welcometit">欢迎进入货先生®</h3>
      <div class="edition_box" v-if="userType == 1">
        <el-badge is-dot class="badge">
          <div class="edition" href="https://hhy.cargocn.com/download/hhypdf/hhy-0825.pdf" target="_blank" @click="goVersion">点我查看更新文档</div>
        </el-badge>
      </div>
      <img
        class="welcomeimg"
        src="https://cargocnwebimage.oss-cn-beijing.aliyuncs.com/hhypc/hhywelcome1.png"
      />
      <div class="welcomeBottom">
        版本号：hhy20230320
        <!-- <div class="edition" href="https://hhy.cargocn.com/download/hhypdf/hhy-0825.pdf" target="_blank" @click="goVersion">点我查看更新文档</div> -->
        <!-- <iframe
          :src="url"
          type="application/x-google-chrome-pdf"
          width="100%"
          height="100%"
        /> -->
      </div>
    </div>
  </template>
  
  
  <script>
  import { mapState, mapActions } from "vuex";
  export default {
    data() {
      return {
        imageList: [],
        dialogImageUrl: "",
        dialogVisible: false,
        options: [],
        value: "",
          url: ``,
      };
    },
    computed: {
      routes() {
        return this.$store.state.sharing.routes;
      },
      userType() {
        return this.$store.state.sharing.userInfo.userType
      }
    },
    mounted() {
      this.url=`https://hhy.cargocn.com/download/hhypdf/hhy-0415.pdf`;
    },
    methods: {
      goVersion(){
        // this.$router.push({
        //     path: "/version"
        //   });
        var data = {
          name: '版本管理',
          path: '/version',
        }
        this.$root.$emit('routeEvent', data)
      },
    }
  };
  </script>
  
  <style scoped>
  .welcome {
    margin: 50px;
  }
  .linkTo {
    width: 80px;
    height: 30px;
    background: #5888c3;
    border-radius: 10px;
    text-align: center;
    margin-left: 10px;
    color: #fff;
  }
  .welcometit {
    font-size: 60px;
    font-weight: bold;
    margin-left: 10%;
    font-style: italic;
    margin-top: 260px;
    color: #0070b1;
    margin-bottom: 30px;
  }
  .welcomeimg {
    width: 45%;
    position: absolute;
    right: 3%;
    bottom: 23%;
  }
  .welcomeBottom {
    position: absolute;
    right: 32px;
    bottom: 10px;
    font-size: 16px;
    color: #aaaaaa;
    display: flex;
    align-items: center;
  }
  
  .edition {
    width: 144px;
    height: 44px;
    background: #0072AD;
    border-radius: 8px 8px 8px 8px;
    /* opacity: 1; */
    color: white;
    line-height: 44px;
    text-align: center;
    font-size: 14px;
    cursor: pointer;
  }
  .badge{
    margin-top: 10px;
    margin-right: 40px;
  }
  .edition_box{
    margin-left: 10%;
    
  }
  </style>
  


// WEBPACK FOOTER //
// src/page/welcomeY.vue